{
  "systemId": "home",
  "stations": [
    {
      "id": "hub",
      "name": "Charter Hub",
      "faction": "authority",
      "look": "neutral",
      "assetId": "station.hub",
      "baySocket": "DOCK_BAY_0",
      "position": [-3000, 300, -13200],
      "faceToward": [0, 0, 0],
      "rollDeg": 0,
      "services": ["market", "outfitting", "repair", "lease", "contracts"],
      "outfitting": ["pdc", "laser", "mining", "salvage", "cargo", "shield", "power", "thrusters", "scanner"],
      "prices": {
        "wares": { "ferrite": 0.8, "silicates": 1.0, "ice": 1.25, "titanium": 0.8, "platinum": 0.7 },
        "components": 1.0,
        "dataCores": 1.0
      },
      "sells": ["ice"],
      "capacityT": 200,
      "commsSeed": 101,
      "desk": {
        "leaseClerk": { "name": "Ines Duarte", "role": "Registry clerk" },
        "claimOfficer": { "name": "Commissioner Hale", "role": "Charter Office" },
        "claimStamp": "ENTERED IN THE CHARTER REGISTRY · CHARTER OFFICE · HALE",
        "boardLine": { "speaker": "Meridian contracts desk", "text": "If you ever find anything on Tethys, we pay better than the Wire." },
        "raidersThanks": {
          "speaker": "Commissioner Hale, Charter Office",
          "text": "Thank you for clearing that group. The lanes are the Charter's to keep open, and this quarter you kept one of them. It's noted on your registry line."
        }
      }
    },
    {
      "id": "refinery",
      "name": "Tethys Refinery",
      "faction": "tethys",
      "look": "player_lease",
      "assetId": "station.refinery",
      "baySocket": "DOCK_BAY_0",
      "position": [11000, -400, -5000],
      "faceToward": [0, 0, 0],
      "rollDeg": 0,
      "services": ["market", "outfitting", "repair", "contracts"],
      "outfitting": ["mining", "cargo", "scanner"],
      "prices": {
        "wares": { "ferrite": 1.25, "silicates": 1.25, "ice": 0.9, "titanium": 1.25, "platinum": 1.25, "tetherstone": 1.0 },
        "components": null,
        "dataCores": null
      },
      "sells": ["ferrite", "silicates", "titanium"],
      "capacityT": 200,
      "commsSeed": 202,
      "desk": {
        "receipt": {
          "issuer": "Tethys Mining Combine · Refinery receipt",
          "signedBy": { "name": "Maren Voss", "role": "Chief Executive" }
        }
      }
    },
    {
      "id": "scrapyard",
      "name": "Mutual Scrapyard",
      "faction": "mutual",
      "look": "first_rush",
      "assetId": "station.scrapyard",
      "baySocket": "DOCK_BAY_0",
      "position": [-13600, 600, -1000],
      "faceToward": [0, 0, 0],
      "rollDeg": 0,
      "services": ["market", "outfitting", "repair", "contracts"],
      "outfitting": ["salvage", "pdc", "laser"],
      "prices": { "wares": {}, "components": 1.25, "dataCores": null },
      "sells": [],
      "capacityT": 200,
      "commsSeed": 303,
      "desk": {
        "marks": ["mark_first_charter", "mark_rush_prime_hex"],
        "plate": "Bay plate, under the Mutual's paint: the first Charter's mark, and beside it a plain hexagon with no notch."
      }
    }
  ]
}
